'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.CHYBA = exports.POZASTAVEN = exports.NEZTOTOZNEN = exports.ZTOTOZNEN = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-04-03T14:18:46Z                      #

// ##############################################################

/**
 * Stav ztotožnění subjektu vůči základním regstrům. @author Pavel Stánek [pavel.stanek@marbes.cz] @since 01.02.2017
 */

/**
 * Ztotožněn.
 */
var ZTOTOZNEN = exports.ZTOTOZNEN = 'ZTOTOZNEN';

/**
 * Neztotožněn.
 */
var NEZTOTOZNEN = exports.NEZTOTOZNEN = 'NEZTOTOZNEN';

/**
 * Pozastaven.
 */
var POZASTAVEN = exports.POZASTAVEN = 'POZASTAVEN';

/**
 * Chyba ISZR při ztotožnění.
 */
var CHYBA = exports.CHYBA = 'CHYBA';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [ZTOTOZNEN, NEZTOTOZNEN, POZASTAVEN, CHYBA];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, ZTOTOZNEN, { caption: 'Ztotožněn.' }), (0, _defineProperty3.default)(_params, NEZTOTOZNEN, { caption: 'Neztotožněn.' }), (0, _defineProperty3.default)(_params, POZASTAVEN, { caption: 'Pozastaven.' }), (0, _defineProperty3.default)(_params, CHYBA, { caption: 'Chyba ISZR při ztotožnění.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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